import { render } from "./HostDevicesTransfer.vue?vue&type=template&id=d4d3b996&scoped=true"
import script from "./HostDevicesTransfer.vue?vue&type=script&lang=js"
export * from "./HostDevicesTransfer.vue?vue&type=script&lang=js"

import "./HostDevicesTransfer.vue?vue&type=style&index=0&id=d4d3b996&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d3b996"]])

export default __exports__